<template>
  <div>
    <vue-editor
      placeholder="Content"
      v-model="inventory.bio"
      :editorToolbar="customToolbar"
      id="editor1"
      class="my-3"
    ></vue-editor>
    <div class="d-flex justify-end pa-3">
      <v-btn
        depressed
        color="var(--g)"
        @click="updateData"
        class="text-capitalize"
        dark
        >Save</v-btn
      >
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "updateBio",
  props: ["inventory"],
  computed: {
    ...mapState({
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }],
      ],
    };
  },
  methods: {
    updateData() {
      this.loading = true;
      let body = null;
      if (this.role == "SCHOLAR") {
        body = {
          about: this.inventory.bio,
          id: this.inventory.id,
        };
      } else {
        body = this.inventory;
      }
      let role =
        this.role == "TF"
          ? "tf"
          : this.role == "SCHOLAR"
          ? "scholar"
          : "vendor_user";
      let data = {
        path: `manage/${role}/update`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
